const storeName = 'display-logs'

export const logs = {
  namespaced: true,
  state: {
    advertLogsSearch: localStorage.getItem(storeName + '-advert-logs-search'),
    aliveLogsSearch: localStorage.getItem(storeName + '-alive-logs-search'),
    bootLogsSearch: localStorage.getItem(storeName + '-boot-logs-search'),
    downloadLogsSearch: localStorage.getItem(storeName + '-download-logs-search'),
    elevatorDayLogsSearch: localStorage.getItem(storeName + '-elevatorDay-logs-search'),
    elevatorMonthLogsSearch: localStorage.getItem(storeName + '-elevatorMonth-logs-search'),
    elevatorWeekLogsSearch: localStorage.getItem(storeName + '-elevatorWeek-logs-search'),
    emailLogsSearch: localStorage.getItem(storeName + '-email-logs-search'),
    fileLogsSearch: localStorage.getItem(storeName + '-file-logs-search'),
    offlineLogsSearch: localStorage.getItem(storeName + '-offline-logs-search'),
    rideLogsSearch: localStorage.getItem(storeName + '-ride-logs-search'),
    updateLogsSearch: localStorage.getItem(storeName + '-update-logs-search'),
  },
  mutations: {
    logsSearchUpdate(state, search) {
      state[`${search.searchType}LogsSearch`] = search.searchTerm;
      localStorage.setItem(storeName + '-' + search.searchType + '-logs-search', search.searchTerm ? search.searchTerm : '');
    }
  }
}